import { trackUpdateAddress } from 'dux/tracking/actions';
import { appApi } from 'dux/app/api';

type SkincareGoals = {
  goals: Array<string>;
};

type UserAddress = {
  address1: string;
  address2: string;
  city: string;
  country: string;
  is_subscription_address: boolean;
  label: string;
  name: string;
  primary: boolean;
  pubkey: string;
  state: string;
  user: string;
  zipcode: string;
};

const userApiSlice = appApi.injectEndpoints({
  endpoints: (build) => ({
    getSkincareGoals: build.query<SkincareGoals, void>({
      query: () => ({
        url: `v1/account/hair_profile/goals/`,
        searchParams: { category: 'skincare' },
        endpointName: 'user/skincareGoalsQuery',
      }),
      providesTags: ['user'],
      keepUnusedDataFor: 0, // no caching for now
    }),

    getAddresses: build.query<UserAddress[], void>({
      query: () => ({
        url: `v1/account/addresses/`,
        endpointName: 'user/addressesQuery',
      }),
      async onQueryStarted(_args, { dispatch }) {
        dispatch(trackUpdateAddress);
      },
      /**
       * The Built-in refetch strategy provided by RTK Query doesn’t work
       * if caching is enabled, some investigation is needed to fine-tune it.
       */
      keepUnusedDataFor: 0, // no caching for now
    }),
    createUserTag: build.mutation<void, string>({
      query: (segmentName) => ({
        url: `v1/tag_segment/`,
        method: 'POST',
        json: { segment_name: segmentName },
      }),
    }),
  }),
});

export const { useGetSkincareGoalsQuery, useGetAddressesQuery, useCreateUserTagMutation } =
  userApiSlice;
